<template>
  <div
    v-if="newCritereRecherche"
    class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div
      :class="[
        {'hauteur-haut-brief-filtre': errors.length === 0},
        {'hauteur-haut-brief-filtre-errors': errors.length > 0}
      ]"
      class="column is-12 pdb-0">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component
          :messages="errors"
          :error="errors.length > 0"
          @close="errors = []"
          title="general.problemOccurred"
          withEmplyFields/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      :class="[
        {'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}
      ]"
      class="column is-12 overflow-auto is-marginless">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="newCritereRecherche.dates"
            :label="$t('listBonExpedition.filtre.dateExpedition')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listBonExpedition.filtre.nomDestination')">
            <qd-taginput v-if="filteredDestinataires"
                     v-model="destinatairesSelected"
                     :data="filteredDestinataires"
                     autocomplete
                     open-on-focus
                     icon="magnify"
                     type="is-primary"
                     field="prenomNom"
                     @typing="getFilteredDestinataire">
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>
      <button
        class="button mgt-10px border-none has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import inputPeriode from '@/components/general/inputPeriode';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import genererCritereRecherche from '@/services/logistique/bonExpedition/genererCritereRecherche';
import { SET_CRITERES } from '@/store/modules/logistique/bonExpedition-mutation-type';
import { getAllWithTiers as getAllContact } from '@/api/contacts';
import messageErreur from '@/services/general/messageErreur';
import debounce from 'lodash/debounce';

const BonExpedition = createNamespacedHelpers('bonExpedition');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'FiltreBonExpedition',
  data() {
    return {
      newCritereRecherche: null,
      isFetchingDestinataires: false,
      filteredDestinataires: [],
      destinatairesSelected: [],
      errors: [],
    };
  },
  components: {
    inputPeriode,
    errorMsgComponent,
  },
  computed: {
    ...BonExpedition.mapGetters({
      critereRechercheFromStore: 'critereRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...BonExpedition.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    appliquerCritere() {
      this.newCritereRecherche.destinataireIds = this.destinatairesSelected;
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche');
    },
    viderCritere() {
      this.destinatairesSelected = [];
      this.newCritereRecherche = cloneDeep(genererCritereRecherche());
    },
    initializeFiltre() {
      this.newCritereRecherche = cloneDeep(this.critereRechercheFromStore);
    },
    getFilteredDestinataire: debounce(async function getDemandeurs(search) {
      this.filteredDestinataires = [];
      if (!search) return;
      this.isFetchingDestinataires = true;
      try {
        const destinataires = (await getAllContact(
          {
            query: {
              auto: search,
              societeId: this.societeActiveId,
              archive: false,
              type: 'Client',
            },
          },
        )).data.result.items
          .map(destinataire => {
            const prenom = destinataire.prenom ?? '';
            const nom = destinataire.nom ?? '';
            destinataire.prenomNom = `${prenom} ${nom}`.trim();
            return destinataire;
          });
        this.filteredDestinataires = destinataires.filter((destinataire) => {
          return !this.destinatairesSelected.map(
            destinataireSelected => destinataireSelected.id,
          ).includes(destinataire.id);
        });
        this.isFetchingDestinataires = false;
      } catch (e) {
        this.isFetchingDestinataires = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
